import React, { useState } from "react";

const GlobalContext = React.createContext();

const GlobalProvider = ({ children }) => {
  const [themeDark, setThemeDark] = useState(false);
  const [showSidebarDashboard, setShowSidebarDashboard] = useState(false);
  const [applicationModalVisible, setApplicationModalVisible] = useState(false);
  const [signInModalVisible, setSignInModalVisible] = useState(false);
  const [signUpModalVisible, setSignUpModalVisible] = useState(false);
  const [videoModalVisible, setVideoModalVisible] = useState(false);
  const [videoUrl, setVideoUrl] = useState("https://www.youtube.com/watch?v=zlInYm2JrFw");
  const [authModalVisible, setAuthModalVisible] = useState(false);
  const [authModalOpenAsSignUp, setAuthModalOpenAsSignUp] = useState(false);
  const [activationFormVisible, setActivationFormVisible] = useState(false);
  const [activationFormPlanType, setActivationFormPlanType] = useState(null); // "freemium" | "enterprise" | "insights" | "bidding" | "gem" | null - when set, only that plan form is shown
  const [activationFormSource, setActivationFormSource] = useState(null);
  const [activationFormDisplaySummary, setActivationFormDisplaySummary] = useState(null);
  const [postLoginPlanPopupVisible, setPostLoginPlanPopupVisible] = useState(false);
  const [visibleOffCanvas, setVisibleOffCanvas] = useState(false);
  const [header, setHeader] = useState({
    theme: "light",
    bgClass: "default",
    variant: "primary",
    align: "left",
    isFluid: false,
    button: null, // profile, account, null
    buttonText: "",
    reveal: true,
  });
  const [footer, setFooter] = useState({
    theme: "dark",
    style: "style1", //style1, style2
  });

  const toggleTheme = () => {
    setThemeDark(!themeDark);
  };

  const toggleSidebarDashboard = () => {
    setShowSidebarDashboard(!showSidebarDashboard);
  };

  const setSidebarDashboardVisible = (isVisible) => {
    setShowSidebarDashboard(!!isVisible);
  };

  const toggleVideoModal = (url) => {
    if (url) {
      setVideoUrl(url);
    }
    setVideoModalVisible(!videoModalVisible);
  };

  const toggleApplicationModal = () => {
    setApplicationModalVisible(!applicationModalVisible);
  };

  const toggleSignInModal = () => {
    setSignInModalVisible(!signInModalVisible);
  };

  const toggleSignUpModal = () => {
    setSignUpModalVisible(!signUpModalVisible);
  };

  const toggleAuthModal = () => {
    setAuthModalVisible(!authModalVisible);
  };

  /** Open auth modal with signup form (e.g. for "Sign up to view" CTAs) */
  const openAuthModalForSignUp = () => {
    setAuthModalOpenAsSignUp(true);
    setAuthModalVisible(true);
  };

  const toggleActivationForm = () => {
    setActivationFormVisible((prev) => !prev);
    if (activationFormVisible) {
      setActivationFormPlanType(null);
      setActivationFormSource(null);
      setActivationFormDisplaySummary(null);
    }
  };

  const openActivationForm = (planType, options = {}) => {
    setActivationFormPlanType(planType || null);
    setActivationFormSource(options?.source || null);
    setActivationFormDisplaySummary(options?.displaySummary || null);
    setActivationFormVisible(true);
  };

  const toggleOffCanvas = () => {
    setVisibleOffCanvas(!visibleOffCanvas);
  };

  const closeOffCanvas = () => {
    setVisibleOffCanvas(false);
  };

  return (
    <GlobalContext.Provider
      value={{
        themeDark,
        toggleTheme,
        showSidebarDashboard,
        toggleSidebarDashboard,
        setSidebarDashboardVisible,
        videoModalVisible,
        videoUrl,
        toggleVideoModal,
        applicationModalVisible,
        toggleApplicationModal,
        signInModalVisible,
        toggleSignInModal,
        signUpModalVisible,
        toggleSignUpModal,
        authModalVisible,
        authModalOpenAsSignUp,
        setAuthModalOpenAsSignUp,
        toggleAuthModal,
        openAuthModalForSignUp,
        activationFormVisible,
        activationFormPlanType,
        activationFormSource,
        activationFormDisplaySummary,
        toggleActivationForm,
        openActivationForm,
        postLoginPlanPopupVisible,
        setPostLoginPlanPopupVisible,
        visibleOffCanvas,
        toggleOffCanvas,
        closeOffCanvas,
        header,
        setHeader,
        footer,
        setFooter,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalContext;
export { GlobalProvider };
